import { FC } from 'react';
import { Controller } from 'react-hook-form';
import { Checkbox } from 'team-hero-ui';
import { useTranslation } from 'react-i18next';

import {
  LinkStyled,
  WrapperContainerStyled,
  WrapperStyled,
} from './FormFooter.styled';
import ModalValidationWrapper from 'components/Modals/AddEditModal/ModalValidationWrapper';
import { IFormFooterProps } from './FormFooter.types';

const FormFooter: FC<IFormFooterProps> = ({ privacyTermsLink, control }) => {
  const { t } = useTranslation('form');

  return (
    <Controller
      name='acceptedRegulations'
      control={control}
      defaultValue={false}
      render={({ field: { onChange, value }, fieldState: { error } }) => (
        <WrapperContainerStyled>
          <ModalValidationWrapper text={error?.message}>
            <WrapperStyled>
              <Checkbox checked={value} onChange={(_, val) => onChange(val)} />
              <span>
                {t('termsAndConditions.text')}
                <LinkStyled href={privacyTermsLink}>
                  {t('termsAndConditions.linkText')}
                </LinkStyled>
              </span>
            </WrapperStyled>
          </ModalValidationWrapper>
        </WrapperContainerStyled>
      )}
    />
  );
};

export default FormFooter;
